import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Alert, Button, Row } from 'reactstrap'
import AutoTable from 'components/AutoTable'
import { IsRosteredBadge } from '../../../../components/IsRosteredBadge/IsRosteredBadge'

import { SSLicenseIdColContainer } from './LicenseGrid.styles'

const resolveSchoolName = row =>
  row.siteName ? row.siteName : row.site && row.site.name ? row.site.name : ''

const LicenseGrid = ({ licenses, onEditLicense }) => {
  const columns = [
    {
      title: 'SS License ID',
      fieldValue: row => {
        return (
          <SSLicenseIdColContainer>
            <Link to={`/css-admin/licenses/${row.id}`}>{row.id}</Link>
            <IsRosteredBadge isRostered={row.isRostered} />
          </SSLicenseIdColContainer>
        )
      },
      sortValue: 'id',
    },
    {
      title: 'NS License ID',
      fieldValue: row => {
        return (
          <Link to={`/css-admin/licenses/${row.id}`}>{row.nsLicenseId}</Link>
        )
      },
      sortValue: 'nsLicenseId',
    },
    {
      title: 'Program Codes',
      fieldValue: row => {
        const sku =
          row && row.product ? row.product.programCodes.join(', ') : ''
        return sku
      },
    },
    {
      title: 'Sku',
      fieldValue: row => {
        const skuValue = row && row.product ? row.product.sku.skuValue : ''
        return skuValue
      },
    },
    {
      title: 'Product',
      fieldValue: row => {
        const description = row && row.product ? row.product.description : ''
        return description
      },
    },
    {
      title: 'School',
      fieldValue: row => {
        const schoolName = resolveSchoolName(row)
        return <Link to={`/css-admin/sites/${row.siteId}`}>{schoolName}</Link>
      },
      sortValue: resolveSchoolName,
    },
    {
      title: '',
      fieldValue: license => {
        return (
          <Button
            color="light"
            onClick={() => onEditLicense(license)}
            size="sm"
          >
            <i className="fas fa-pencil-alt text-info" />
            &nbsp;Edit
          </Button>
        )
      },
      headerStyle: { width: '6rem' },
      cellClassName: 'text-center',
      sort: false,
      filter: false,
    },
  ]

  return licenses.length ? (
    <Row>
      <AutoTable
        borderless
        columns={columns}
        filter
        headThemeLight
        rows={licenses}
        sort
      />
    </Row>
  ) : (
    <Alert color="warning">No results found</Alert>
  )
}

LicenseGrid.propTypes = {
  licenses: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEditLicense: PropTypes.func.isRequired,
}

export default LicenseGrid



// WEBPACK FOOTER //
// ./src/containers/css-admin/subscriptions/licenseGrid/LicenseGrid.js